import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'

export const linkedReceiptShape = {
  id: z.string(),
  name: z.string(),
  asset: z.string().nullable(),
}

export const receiptShape = {
  id: z.string(),
  name: z.string(),
  reimburseTo: z.string().optional(),
  asset: z.string(),
  linkedReceiptsRef: z.array(z.object(linkedReceiptShape)).optional(),
  // Standing notes folded into every AI generation for this receipt.
  notes: z.string().nullable().optional(),
  created: z.string(),
}

export const createReceiptShape = {
  name: z.string(),
  reimburseTo: z.string().optional(),
  asset: z.instanceof(File),
}

export const receiptFilterShape = {
  expenseGroup__isnull: z.boolean(),
  organization: z.string().array(),
  search: z.string(),
}

export type LinkedReceipt = GetInferredFromRaw<typeof linkedReceiptShape>
export type Receipt = GetInferredFromRaw<typeof receiptShape>
export type CreateReceipt = GetInferredFromRaw<typeof createReceiptShape>
export type ReceiptFilter = GetInferredFromRaw<typeof receiptFilterShape>
